import { render } from "./SessionDetail.vue?vue&type=template&id=71705222&lang=true"
import script from "./SessionDetail.vue?vue&type=script&lang=js"
export * from "./SessionDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/basta-new/wp-content/themes/sands-events-subtheme/can-rendering/walkuere_vue_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__